"use strict";

var cached = [];

exports.loadScript = function (src, cb) {
    if (~cached.indexOf(src)) {
        cb();
        return;
    }

    var script = document.createElement("script");
    script.src = src;
    script.onload = function () {
        cached.push(src);
        cb();
    };
    document.getElementsByTagName("head")[0].appendChild(script);
};


//////////////////
// WEBPACK FOOTER
// ./~/@dp/whereami/lib/util.js
// module id = 398
// module chunks = 0